import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import BlogSearchBar from "@/pages/blog/components/BlogSearchBar";
import PostCard from "@/pages/blog/components/PostCard";
import { contentCategories, getPopularPosts, searchPosts } from "@/pages/blog/blogData";

export default function SearchResults({ query }: { query: string }) {
  const results = searchPosts(query);
  const popular = getPopularPosts(3);

  return (
    <div className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="mx-auto max-w-3xl">
          <BlogSearchBar defaultValue={query} />
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-between gap-3">
          <p className="text-sm text-foreground-600">
            {query ? (
              <>
                <strong className="font-semibold text-foreground-950">{results.length}</strong> resultado
                {results.length === 1 ? "" : "s"} para{" "}
                <span className="font-semibold text-foreground-950">&ldquo;{query}&rdquo;</span>
              </>
            ) : (
              "Digite uma palavra-chave para buscar no blog."
            )}
          </p>
          <Link to="/blog" className="text-sm font-semibold text-primary-600 hover:text-primary-700">
            Voltar para o blog
          </Link>
        </div>

        {results.length > 0 ? (
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {results.map((post, index) => (
              <Reveal key={post.slug} delay={index * 40}>
                <PostCard post={post} />
              </Reveal>
            ))}
          </div>
        ) : (
          <div className="mt-10">
            <div className="rounded-xl border border-background-200 bg-background-100/70 p-8 text-center">
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-500">
                <i className="ri-search-line text-2xl" aria-hidden="true"></i>
              </span>
              <h2 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                {query ? "Nenhum artigo encontrado" : "O que você quer aprender?"}
              </h2>
              <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-foreground-600">
                {query
                  ? "Tente outra palavra-chave ou explore uma das categorias abaixo."
                  : "Pesquise por um assunto ou navegue pelas categorias do blog."}
              </p>
            </div>

            <div className="mt-8">
              <p className="text-xs font-semibold uppercase tracking-wider text-foreground-400">
                Explore por categoria
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                {contentCategories.map((category) => (
                  <Link
                    key={category.slug}
                    to={`/blog/${category.slug}`}
                    className="inline-flex items-center gap-2 rounded-full border border-background-300 px-3.5 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                  >
                    <i className={category.icon} aria-hidden="true"></i>
                    {category.shortName}
                  </Link>
                ))}
              </div>
            </div>

            <div className="mt-10">
              <p className="text-xs font-semibold uppercase tracking-wider text-foreground-400">
                Sugestões de leitura
              </p>
              <div className="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {popular.map((post) => (
                  <PostCard key={post.slug} post={post} />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}